import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Button, FormValidators, ISelectItem, RadioButton } from 'app-core';
import { Subject, takeUntil } from 'rxjs';

import { DialogService } from 'app-shared-ui';
import { ContactUsService } from 'app-service';

import ButtonType = Data.Core.ButtonType;

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [ContactUsService]
})
export class ContactUsComponent {
  @ViewChild('errorMsg', { static: true })
  public errorMsg!: TemplateRef<any>;
  @ViewChild('successMsg', { static: true })
  public successMsg!: TemplateRef<any>;
  @ViewChild('successMsgTitle', { static: true })
  public successMsgTitle!: TemplateRef<any>;
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  public personName = new FormControl('', Validators.required);
  public email = new FormControl('', FormValidators.userEmail);
  public contact = new FormControl('', FormValidators.userMobile);
  public message = new FormControl('', Validators.required);
  public interestControl = new FormControl('');
  public contactUsForm: FormGroup;
  public interestList: Array<ISelectItem> = [
    {
      displayText: 'Creating a free profile on ArogyaLine.com',
      value: 1
    },
    {
      displayText: 'Free trial of a software to manage my clinic(s)/hospital(s)',
      value: 2
    },
    {
      displayText: 'Software to manage my clinic(s)/hospital(s)',
      value: 3
    },
    {
      displayText: 'Advertising my clinic(s)/hospital(s) on ArogyaLine.com',
      value: 4
    },
    {
      displayText: 'Partnerships for clinic management software sales',
      value: 5
    },
    {
      displayText: 'Support for an existing product/subscription',
      value: 6
    },
    {
      displayText: 'Other',
      value: 7
    },
  ];
  public selectedInterest: any = undefined;
  public roleList: Array<RadioButton> = [
    {
      label: 'Doctor',
      value: 1
    },
    {
      label: 'Patient',
      value: 2
    }
  ];
  public saveAccountButton: Button = new Button({
    label: 'Submit',
    type: ButtonType.button,
    action: () => this.createContactUsForm(),
    disabled: () => !this.contactUsForm.valid,
  });

  public constructor(
    private readonly _contactUsService: ContactUsService,
    private readonly _cdRef: ChangeDetectorRef,
    private readonly _formBuilder: FormBuilder,
    private readonly _dialogService: DialogService
  ) {
    this.contactUsForm = this._formBuilder.group([
      this.personName,
      this.contact,
      this.email,
      this.message,
      this.interestControl
    ]);
  }

  public onInterestSelect(interest: ISelectItem): void {
    this.selectedInterest = this.interestList.filter(itrst => itrst.value === interest.value)[0].displayText;
  }

  private createContactUsForm(): void {
    this._contactUsService.createContactUsForm({
      name: this.personName.value || '',
      email: this.email.value || '',
      mobile: this.contact.value || '',
      message: this.message.value || '',
      interest: this.selectedInterest || '',
    })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        () => {
          this._dialogService.openDialog({
            header: this.successMsgTitle,
            body: this.successMsg,
          });
          this._cdRef.markForCheck();
        },
        () => {
          this._dialogService.openDialog({
            body: this.errorMsg,
          });
        },
        () => this.contactUsForm.reset());
  }
}
